import { createContext, useContext } from "react";

export interface OptimizelyUserAttributes {
  userId?: string;
  attributes?: { [key: string]: string | number | boolean };
}

export const OptimizelyUserContext = createContext<OptimizelyUserAttributes>({});

export const useOptimizelyUser = () => {
  return useContext(OptimizelyUserContext);
};
